import { useNavigate } from 'react-router';
import { countSession, SESSION_KINDS, type OpsSession } from '@ecobox/firebase';
import { Badge, Button, TimeInState } from '@ecobox/ui';
import { useLedgerById } from '../sessions';

/** The sessions the person has started and not finished, each one tap from where they left off. */
export function SessionCards({ sessions }: { sessions: readonly OpsSession[] }) {
  const navigate = useNavigate();
  const ledger = useLedgerById();
  if (sessions.length === 0) return null;
  return (
    <ul className="ops-list" aria-label="Sessions in progress">
      {sessions.map((s) => {
        const counts = countSession(s, ledger);
        return (
          <li key={s.id} className="ops-row" data-tone={counts.unsent > 0 ? 'waiting' : 'ok'}>
            <div className="ops-row__top">
              <strong>{SESSION_KINDS[s.kind].label}</strong>
              <Badge tone="info">{counts.good} scanned</Badge>
            </div>
            <div>{s.targetLabel}</div>
            <div className="ops-muted">
              {counts.unsent > 0 ? `${counts.unsent} not sent yet · ` : ''}
              {counts.held > 0 ? `${counts.held} held back · ` : ''}
              started <TimeInState since={s.startedAt} suffix="ago" />
            </div>
            <Button
              size="touch"
              variant="cta"
              block
              onClick={() => void navigate(`/session/${s.id}`)}
            >
              Continue scanning
            </Button>
          </li>
        );
      })}
    </ul>
  );
}
